import React from 'react'
import Terms from '../../Componet/Terms'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import Calculator from '../../Componet/Calculator/Calculator'


function TermsConditions() {
    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"Pricing Calculator"} />
            <div class="page-content">
                <Calculator></Calculator>
                <NewsletterL1 />
            </div>
        </>
    )
}

export default TermsConditions
